<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousSalesView"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="30"></md-layout>

          <md-layout md-flex>
            <h2>B/L ( NON-US )</h2>
            <md-layout md-flex="45"></md-layout>
          </md-layout>
        </md-layout>

        <div v-if="BLRaised.conFclBLNonUsId!='' || clientList.length>0">
          <hr class="hr-s" />
          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <label for="fclConsoMultipleClientId" v-if="BLRaised.conFclBLNonUsId==''">Client Name</label>
              <model-list-select
                v-if="BLRaised.conFclBLNonUsId==''"
                :list="clientList"
                id="fclConsoMultipleClientId"
                v-model="BLRaised.fclConsoMultipleClientId"
                option-value="fclConsoMultipleClientId"
                option-text="clientName"
                placeholder="Select  Client Name"
              ></model-list-select>
              <md-layout md-flex="100" v-else>
                <label for="clientName">Client Name</label>
                <b-form-input :formatter="capitalizeAll" disabled v-model="BLRaised.clientName"></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="20">
              <label for="blType">B/L Stage</label>
              <model-list-select
                :list="blStageList"
                v-model="BLRaised.blStage"
                option-value="blStageVal"
                option-text="blStageTxt"
                placeholder="Select B/L Stage"
              ></model-list-select>
              <span class="error" v-if="!BLRaised.blStage">{{errorBLRaised.blStage}}</span>
            </md-layout>
          </md-layout>
          <!-- <md-layout gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="90">
              <md-layout md-flex="100">
                <label>Address</label>
                <b-form-textarea :formatter="capitalizeAll"
                  id="clientAddress"
                  name="clientAddress"
                  v-model="BLRaised.clientAddress"
                ></b-form-textarea>
              </md-layout>
            </md-layout>
          </md-layout>-->
          <md-layout gutter style="margin-top:2%">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label>CONSIGNOR</label>
            </md-layout>

            <md-layout md-flex="40">
              <label>CONSIGNEE ( OR ORDER)</label>
            </md-layout>
          </md-layout>
          <md-layout gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <!-- <VueTrix v-model="BLRaised.consignor" placeholder="Enter Content"/> -->
                <!-- <div class="quill-editor" v-model="BLRaised.consignor" v-quill:myQuillEditor="{}"></div> -->
                <quill-editor
                  ref="myTextEditor"
                  v-model="BLRaised.consignor"
                  :options="editorOption"
                ></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.consignor">{{errorBLRaised.consignor}}</span>
            </md-layout>

            <md-layout md-flex="40">
              <md-layout md-flex="100">
                <quill-editor
                  ref="myTextEditor"
                  v-model="BLRaised.consignee"
                  :options="editorOption"
                ></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.consignee">{{errorBLRaised.consignee}}</span>
            </md-layout>
          </md-layout>
          <md-layout gutter>
            <md-layout
              md-flex="30"
              v-for="(singleInput, index) in BLRaised.notifyList"
              :key="index"
              style="margin-top:3%"
            >
              <md-layout md-flex="100">
                <md-layout md-flex="15"></md-layout>
                <md-layout md-flex="60">
                  <label>{{ notifyArray[index] }} Notify Party</label>
                </md-layout>
                <md-layout md-flex="15" v-if="index>1">
                  <md-button
                    class="md-icon-button md-raised md-dense"
                    @click="removeNotify(index)"
                    style="min-height:20px;height:20px"
                  >
                    <md-icon>close</md-icon>
                  </md-button>
                </md-layout>
              </md-layout>

              <md-layout md-flex="100">
                <md-layout md-flex="15"></md-layout>
                <md-layout md-flex="70">
                  <quill-editor ref="myTextEditor" v-model="singleInput.inputValue"></quill-editor>
                </md-layout>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label class="showMoreData" @click="addNotify">Add Notify</label>
              <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Bill of Lading No</label>
                <b-form-input :formatter="capitalizeAll" id="billLading" name="billLading" v-model="BLRaised.billLading"></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.billLading">{{errorBLRaised.billLading}}</span>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Shipment Reference Number</label>
                <b-form-input :formatter="capitalizeAll"
                  id="shippingReferenceNum"
                  name="shippingReferenceNum"
                  v-model="BLRaised.shippingReferenceNum"
                ></b-form-input>
              </md-layout>
              <span
                class="error"
                v-if="!BLRaised.shippingReferenceNum"
              >{{errorBLRaised.shippingReferenceNum}}</span>
            </md-layout>

            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Type of Move</label>
                <b-form-input :formatter="capitalizeAll" id="typeMove" name="typeMove" v-model="BLRaised.typeMove"></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.typeMove">{{errorBLRaised.typeMove}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>No. of Original B/L</label>
                <b-form-input :formatter="capitalizeAll" id="originalBill" name="originalBill" v-model="BLRaised.originalBill"></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.originalBill">{{errorBLRaised.originalBill}}</span>
            </md-layout>
          </md-layout>

          <!-- <md-layout gutter>
            <md-layout
              md-flex="30"
              v-for="(singleInput, index) in BLRaised.notifyList"
              :key="index"
              style="margin-top:3%"
            >
              <md-layout md-flex="100">
                <md-layout md-flex="10"></md-layout>
                <md-layout md-flex="40">
                  <label>{{singleInput.text}} Notify Party</label>
                </md-layout>
              </md-layout>
              <md-layout md-flex="100">
                <md-layout md-flex="10"></md-layout>
                <md-layout md-flex="60">
                  <quill-editor
                    ref="myTextEditor"
                    v-model="singleInput.inputValue"
                    :options="editorOption"
                  ></quill-editor>
                </md-layout>
              </md-layout>
            </md-layout>
          </md-layout>-->
          <!-- <md-layout md-flex="40">
              <VueTrix v-model="editorContent" placeholder="Enter Content"/>
          </md-layout>-->
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Pre­Carriage By</label>
                <b-form-input :formatter="capitalizeAll" id name v-model="BLRaised.preCarriage"></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.preCarriage">{{errorBLRaised.preCarriage}}</span>
            </md-layout>

            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="20">
              <label>Place of Acceptance/Date</label>

              <date-picker
                v-model="BLRaised.acceptanceDate"
                lang="en"
                type="datetime"
                format="YYYY-MM-DD hh:mm "
                :minute-step="1"
                id="acceptanceDate"
              ></date-picker>
              <span class="error" v-if="!BLRaised.acceptanceDate">{{errorBLRaised.acceptanceDate}}</span>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Transport Mode</label>
                <b-form-input :formatter="capitalizeAll" id="modeMean" name="modeMean" v-model="BLRaised.modeMean"></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.modeMean">{{errorBLRaised.modeMean}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Vessel/Voy</label>
                <b-form-input :formatter="capitalizeAll" id="vesselVoy" name="vesselVoy" v-model="BLRaised.vesselVoy"></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.vesselVoy">{{errorBLRaised.vesselVoy}}</span>
            </md-layout>

            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>Route/Place of Transhipment(If Any</label>
                <b-form-input :formatter="capitalizeAll" id="routePlace" name="routePlace" v-model="BLRaised.routePlace"></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.routePlace">{{errorBLRaised.routePlace}}</span>
            </md-layout>
          </md-layout>

          <md-layout gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Port of Loading</label>
                <b-form-input :formatter="capitalizeAll" id="portLoad" name="portLoad" v-model="BLRaised.portLoad"></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.portLoad">{{errorBLRaised.portLoad}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Port of Discharge</label>
                <b-form-input :formatter="capitalizeAll"
                  id="portDischarge"
                  name="portDischarge"
                  v-model="BLRaised.portDischarge"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.portDischarge">{{errorBLRaised.portDischarge}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>Final Place of Delivery</label>
                <b-form-input :formatter="capitalizeAll"
                  id="placeDilievery"
                  name="placeDilievery"
                  v-model="BLRaised.placeDilievery"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.placeDilievery">{{errorBLRaised.placeDilievery}}</span>
              <!--  -->
            </md-layout>
          </md-layout>
          <hr />
          <md-layout gutter>
            <md-layout md-flex="5"></md-layout>
            <!-- <md-layout md-flex="30">
              <label>Container No. / Marks and Nos</label>
            </md-layout>-->
            <md-layout md-flex="85">
              <label>Description of Packages and Goods</label>
            </md-layout>
            <!-- <md-layout md-flex="20">
              <label>No. of Pkgs</label>
            </md-layout>-->
          </md-layout>
          <md-layout gutter>
            <md-layout md-flex="5"></md-layout>
            <!-- <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor
                  ref="myTextEditor"
                  v-model="BLRaised.containerMarks"
                  :options="editorOption"
                ></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.containerMarks">{{errorBLRaised.containerMarks}}</span>
            </md-layout>-->
            <md-layout md-flex="85">
              <md-layout md-flex="100">
                <!-- <b-form-textarea :formatter="capitalizeAll"
                  id="remark"
                  style="height:100px"
                  name="remark"
                  v-model="BLRaised.descriptionGood"
                ></b-form-textarea>-->
                <quill-editor
                  ref="myTextEditor"
                  style=" width: 900px !important;"
                  v-model="BLRaised.descriptionGood"
                  :options="editorOption"
                ></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.descriptionGood">{{errorBLRaised.descriptionGood}}</span>
            </md-layout>
            <!-- <md-layout md-flex="10">
              <md-layout md-flex="100">
                <quill-editor ref="myTextEditor" v-model="BLRaised.noPkg" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.noPkg">{{errorBLRaised.noPkg}}</span>
            </md-layout>-->
          </md-layout>

          <!-- <md-layout gutter style="margin-top:2%">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label>Gross Weight</label>
            </md-layout>

            <md-layout md-flex="30">
              <label>Net Weight</label>
            </md-layout>
            <md-layout md-flex="30">
              <label>Measurement</label>
            </md-layout>
          </md-layout>
          <md-layout gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor v-model="BLRaised.grossWeight" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.grossWeight">{{errorBLRaised.grossWeight}}</span>
            </md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor v-model="BLRaised.netWeight" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.netWeight">{{errorBLRaised.netWeight}}</span>
            </md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor v-model="BLRaised.measurement" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.measurement">{{errorBLRaised.measurement}}</span>
            </md-layout>
          </md-layout>-->
          <md-layout gutter style="margin-top:2%">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label>Description of Charges</label>
            </md-layout>
            <md-layout md-flex="30">
              <label>Prepaid</label>
            </md-layout>

            <md-layout md-flex="30">
              <label>Collect</label>
            </md-layout>
          </md-layout>
          <md-layout gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <md-layout md-flex="100">
                  <quill-editor v-model="BLRaised.desCharges" :options="editorOption"></quill-editor>
                </md-layout>
              </md-layout>
              <span class="error" v-if="!BLRaised.desCharges">{{errorBLRaised.desCharges}}</span>
            </md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor v-model="BLRaised.prepaid" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.prepaid">{{errorBLRaised.prepaid}}</span>
            </md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor v-model="BLRaised.collect" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.collect">{{errorBLRaised.collect}}</span>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <label for="blType">Place</label>
              <model-list-select
                :list="PlaceList"
                v-model="BLRaised.placeBranch"
                option-value="PlaceVal"
                option-text="PlaceTxt"
                placeholder="Select Pridel Branch Name"
              ></model-list-select>
              <span class="error" v-if="!BLRaised.placeBranch">{{errorBLRaised.placeBranch}}</span>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <label for="blType">Delievery Agent</label>
              <model-list-select
                :list="AgentList"
                v-model="BLRaised.delieveryAgent"
                option-value="agntColoaderId"
                option-text="agentName"
                placeholder="Select Delievery Agent"
              ></model-list-select>
              <span class="error" v-if="!BLRaised.delieveryAgent">{{errorBLRaised.delieveryAgent}}</span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Total</label>
                <b-form-input :formatter="capitalizeAll" id="total" name="total" v-model="BLRaised.total"></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.total">{{errorBLRaised.total}}</span>
            </md-layout>
          </md-layout>

          <hr class="hr-s" />
          <md-layout md-gutter class="mrgtop-2per">
            <md-layout md-flex="40"></md-layout>
            <md-layout md-flex="20">
              <md-button
                class="md-raised md-primary md-button-color heght-1px"
                id="addButtonLoader"
                @click="addBLRaised"
              >Submit</md-button>
              <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
            </md-layout>
          </md-layout>

          <div class="box" v-if="containerDetail.length>0">
            <div class="box-header">
              <h3 class="box-title">Container Detail</h3>
            </div>
            <hr class="hr-s" />
            <!-- /.box-header -->
            <div class="box-body">
              <table id="clientSB" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>
                          <input 
                            type="checkbox" 
                            v-model="selectAllContainers" 
                            @change="toggleSelectAll"
                            :indeterminate="isIndeterminate"
                          />
                        </th>
                    <th>Container No</th>
                    <th>Container Type</th>
                    <th>Seal No</th>
                    <th>Gross Weight</th>
                    <th>Measurement</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in containerDetail" :key="index">
                    <td>
                          <input 
                            type="checkbox" 
                            v-model="item.selected" 
                            @change="updateSelectAll"
                            :disabled="item.containerWithSplit == 1"
                          />
                        </td>
                    <td>{{item.fclConcontainerNo}}</td>
                    <td>{{item.containerType}}</td>
                    <td>{{item.customSealNo}}</td>
                    <td>{{item.conGrossWeight}}</td>
                    <td>{{item.measurement}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

              <!-- Container selection controls -->
              <div class="mt-3" v-if="containerDetail.length > 0">
                  <div class="alert alert-info">
                    <strong>Container Selection:</strong> Use the checkboxes to select individual containers or use the controls below for bulk operations. 
                    Selected containers can be used for specific operations. Containers with split status are disabled.
                  </div>
                  
                  <!-- Warning when no containers are selected -->
                  <div v-if="!hasSelectedContainers" class="alert alert-warning">
                    <strong>Warning:</strong> Please select at least one container to proceed.
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <b-button 
                        size="sm" 
                        variant="info" 
                        @click="selectAllContainers = true; toggleSelectAll()"
                        class="mr-2"
                      >
                        Select All
                      </b-button>
                      <b-button 
                        size="sm" 
                        variant="secondary" 
                        @click="selectAllContainers = false; toggleSelectAll()"
                        class="mr-2"
                      >
                        Deselect All
                      </b-button>
                    </div>
                    <div class="col-md-6 text-right">
                      <span class="text-muted">
                        Selected: {{ selectedContainersCount }} of {{ selectableContainersCount }} containers
                      </span>
                    </div>
                  </div>
                </div>
            <!-- /.box-body -->
          </div>
        </div>

        <hr class="hr-s" />

        <div class="box" v-if="nonUsBlTable.length>0">
          <div class="box-header">
            <h3 class="box-title">Client BL Details</h3>
          </div>
          <hr class="hr-s" />
          <!-- /.box-header -->
          <Filter-Agency-Modal/>
          <FilterCBModal />
          <ClientCard />
           <ShipmentTrackCard />
          <div class="box-body">
            <table id="clientSB" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Client Name</th>
                  <th>BL Stage</th>
                  <th>Print</th>
                  <th>Download Word</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in nonUsBlTable" :key="index">
                  <td>{{index+1}}</td>
                  <td class="showMoreData" @click="viewEditBLNonUs(item)">{{item.clientName}}</td>
                  <td>{{item.blStage}}</td>
                  <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="Print(item.uploadBLCon)"
                    >
                      <md-icon>print</md-icon>
                    </md-button>
                  </td>
                  <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="downloadWord(item.conFclBLNonUsId)"
                    >
                      <md-icon>cloud_download</md-icon>
                    </md-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>

        <hr class="hr-s" v-if="BLRaised.conFclBLNonUsId=='' && clientList.length==0" />
        <md-layout
          md-gutter
          class="mrgtop-2per"
          v-if="BLRaised.conFclBLNonUsId=='' && clientList.length==0"
        >
          <md-layout md-flex="40"></md-layout>
          <md-layout md-flex="20">
            <md-button
              class="md-raised md-primary md-button-color heght-1px"
              id="addButtonLoader"
              @click="proceedAws"
            >Proceed to AMS Filling</md-button>
            <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
          </md-layout>
        </md-layout>
      </md-card-content>
    </md-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop6"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight") || globalPermissionStatus("Overseas Agent Assignments")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/conBLNonUs");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      selectAllContainers: false,
      isIndeterminate: false,

      selectDateFormat,
      docURL: URL_BASE_DOC,
      isLoading: false,
      content: `<h2 class="ql-align-center"><span class="ql-font-serif">sajnsajknsakjnask content loading..</span></h2>`,
      editorOption: {
        modules: {}
      },
      editorContent: "",
      containerNoName: [],
      getCLientData: [],
      nonUsBlTable: [],
      BLRaised: {
        selected_container:"",
        conFclBLNonUsId: "",
        fclConsoMultipleClientId: "",
        clientName: "",
        clientAddress: "",
        uploadBLCon: "",

        blStage: "",
        consignor: "",
        consignee: "",
        shippingReferenceNum: "",
        typeMove: "",
        originalBill: "",
        notifyList: [
          {
            inputValue: "",
            text: ""
          },
          {
            inputValue: "",
            text: "Second"
          }
        ],

        preCarriage: "",
        acceptanceDate: "",
        billLading: "",
        modeMean: "",
        routePlace: "",
        vesselVoy: "",
        portLoad: "",
        portDischarge: "",
        placeDilievery: "",
        // containerMarks: "",
        // noPkg: "",
        descriptionGood: "",
        // grossWeight: "",
        // netWeight: "",
        // measurement: "",
        desCharges: "",
        prepaid: "",
        collect: "",
        placeBranch: "",
        delieveryAgent: "",
        total: "",
        portLocationType: "NON_USA",
        ffFclConsoExportId: "",
        ffConExecutionId: "",
        conFclBookingId: ""
      },

      notifyArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "FiFth",
        "Sixth",
        "Seventh",
        "Eight",
        "Ninth",
        "Tenth"
      ],

      errorBLRaised: {
        blStage: "",
        consignor: "",
        consignee: "",
        shippingReferenceNum: "",
        typeMove: "",
        originalBill: "",
        containerDetail: [],

        preCarriage: "",
        acceptanceDate: "",
        billLading: "",
        modeMean: "",
        routePlace: "",
        vesselVoy: "",
        portLoad: "",
        portDischarge: "",
        placeDilievery: "",
        // containerMarks: "",
        // noPkg: "",
        descriptionGood: "",
        // grossWeight: "",
        // netWeight: "",
        // measurement: "",
        desCharges: "",
        prepaid: "",
        collect: "",
        placeBranch: "",
        delieveryAgent: "",
        total: ""
      },

      arrayErrorBLRaised: [
        {
          blStage: "Please Select BL Stage",
          consignor: "Please Enter Consignor",
          consignee: "Please Enter Consignee",
          shippingReferenceNum: "Please Enter Shipping Reference",
          typeMove: "Please Enter Type Move",
          originalBill: "Please Enter Bill",

          preCarriage: "Please Enter Pre Carriage",
          acceptanceDate: "Select Acceptance Date",
          billLading: "Please Enter Bill Lading No",
          modeMean: "Please Enter Mode Mean Transport",
          routePlace: "Please Enter Route Place",
          vesselVoy: "Please Enter Vessel Voy",
          portLoad: "Please Enter Port Load",
          portDischarge: "Please Enter Port Discharge",
          placeDilievery: "Please Enter Place Delievery",
          containerMarks: "Please Enter Container Marks",
          noPkg: "Please Enter No of Package",
          descriptionGood: "Please Enter Description Good",
          grossWeight: "Please Enter Gross Weight",
          netWeight: "Please Enter Net Weight",
          measurement: "Please Enter Measurement",
          desCharges: "Please Enter Description Charges",
          prepaid: "Please Enter Prepaid",
          collect: "Please Enter Collect",
          placeBranch: "Please Enter Branch",
          delieveryAgent: "Please Select Delievery Agent",
          total: "Please Enter Total"
        }
      ],

      notifyListArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "Fifth",
        "Sixth",
        "Seven",
        "Eight"
      ],

      blStageList: [
        {
          blStageVal: "DRAFT",
          blStageTxt: "DRAFT"
        },
        {
          blStageVal: "ORIGINAL",
          blStageTxt: "ORIGINAL"
        },

        {
          blStageVal: "NON-NEGOTIABLE",
          blStageTxt: "Non/­Negotiable"
        },
        {
          blStageVal: "SEAWAY",
          blStageTxt: "SEAWAY"
        }
      ],

      PlaceList: [
        {
          PlaceVal: "Delhi",
          PlaceTxt: "Delhi"
        },
        {
          PlaceVal: "Jaipur",
          PlaceTxt: "Jaipur"
        }
      ],
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      AgentList: [],
      validate: true
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },
  watch: {
    BLRaised: {
      handler: function(newVal, oldVal) {
        //    console.log("Here Change obj", newVal, oldVal);
        console.log("Here Change ", this.BLRaised.fclConsoMultipleClientId);
        if (this.BLRaised.fclConsoMultipleClientId != "") {
          let clientArray = this.getCLientData.filter(x => {
            return (
              x.fclConsoMultipleClientId == newVal.fclConsoMultipleClientId
            );
          });

          if (clientArray.length > 0) {
            this.BLRaised.clientAddress = clientArray[0].corporateAddress;
            this.BLRaised.consignor =
              "<p>" +
              clientArray[0].clientName +
              "</p><p>" +
              clientArray[0].corporateAddress +
              "</p>";
          }
        } else {
          this.BLRaised.consignor = "";
        }
      },
      deep: true
    }
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor,
    FilterAgencyModal,
    FilterCBModal,
    ClientCard,
    ShipmentTrackCard,
  },

  computed: {
    containerNoList() {
      return this.containerNoName;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    commodityList() {
      return this.getCommodityData;
    },
    clientList() {
      return this.getCLientData;
    },

     // Container selection computed properties
     selectedContainersCount() {
      return this.getSelectedContainers().length;
    },
    selectableContainersCount() {
      return this.containerDetail.filter(item => item.containerWithSplit != 1).length;
    },
    hasSelectedContainers() {
      return this.selectedContainersCount > 0;
    },
    allContainersSelected() {
      return this.selectedContainersCount === this.selectableContainersCount && this.selectableContainersCount > 0;
    }
  },

  methods: {
     
    // Container selection methods
    toggleSelectAll() {
      this.containerDetail.forEach(item => {
        if (item.containerWithSplit != 1) {
          item.selected = this.selectAllContainers;
        }
      });
      this.updateSelectAll();
    },
    
    updateSelectAll() {
      const selectableContainers = this.containerDetail.filter(item => item.containerWithSplit != 1);
      const selectedContainers = selectableContainers.filter(item => item.selected);
      
      if (selectedContainers.length === 0) {
        this.selectAllContainers = false;
        this.isIndeterminate = false;
      } else if (selectedContainers.length === selectableContainers.length) {
        this.selectAllContainers = true;
        this.isIndeterminate = false;
      } else {
        this.selectAllContainers = false;
        this.isIndeterminate = true;
      }
    },
    
    getSelectedContainers() {
      return this.containerDetail.filter(item => item.selected);
    },
    
    getSelectedContainersMinimal() {
      return this.containerDetail
        .filter(item => item.selected)
        .map(item => ({
          uniqueContainerId: item.ffExecutionContainerId,
          containerNo: item.containerNo
        }));
    },
    
    getSelectedContainerIds() {
      return this.getSelectedContainers().map(item => item.ffExecutionContainerId);
    },
    
    getSelectedContainerNumbers() {
      return this.getSelectedContainers().map(item => item.containerNo);
    },

    
    // Method to select a single container by container number
    selectContainerByNumber(containerNumber) {
      const container = this.containerDetail.find(item => item.containerNo === containerNumber);
      if (container && container.containerWithSplit != 1) {
        container.selected = true;
        this.updateSelectAll();
      }
    },
    
    // Method to deselect a single container by container number
    deselectContainerByNumber(containerNumber) {
      const container = this.containerDetail.find(item => item.containerNo === containerNumber);
      if (container) {
        container.selected = false;
        this.updateSelectAll();
      }
    },
    
    // Method to get containers for operations (uses selected containers if any, otherwise all containers)
    getContainersForOperation() {
      const selectedContainers = this.getSelectedContainers();
      return selectedContainers.length > 0 ? selectedContainers : this.containerDetail;
    },
    
    // Method to auto-select containers from saved data
    autoSelectContainersFromData(selectedContainerData) {
      console.log("priyanshu Singh containerIds1=>", selectedContainerData);
      console.log("priyanshu Singh containerDetail1=>", this.containerDetail);
      if (!selectedContainerData || !this.containerDetail.length) {
        return;
      }
     
      
      try {
        // Clear all current selections first
        this.containerDetail.forEach(container => {
          container.selected = false;
        });
        
        // Handle comma-separated string format (e.g., "167477, 167478, ")
        if (typeof selectedContainerData === 'string') {
          // Split by comma and clean up whitespace and empty values
          const containerIds = selectedContainerData
            .split(',')
            .map(id => id.trim())
            .filter(id => id !== '' && id !== null && id !== undefined);
            console.log("priyanshu Singh containerIds=>", containerIds);
            console.log("priyanshu Singh containerDetail=>", this.containerDetail);
          // Select containers based on uniqueContainerId
          containerIds.forEach(containerId => {
            const container = this.containerDetail.find(item => 
              item.uniqueContainerId == containerId
            );
            
            if (container && container.containerWithSplit != 1) {
              container.selected = true;
            }
          });
        }
        
        // Update the select all state
        this.updateSelectAll();
        
        console.log('Auto-selected containers from saved data:', selectedContainerData);
      } catch (error) {
        console.error('Error auto-selecting containers:', error);
      }
    },
    
    // Method to validate container selection
    validateContainerSelection() {
      const selectedContainers = this.getSelectedContainers();
      if (selectedContainers.length === 0) {
        this.alert.content = "Please select at least one container to proceed";
        this.$refs["addPop"].open();
        return false;
      }
      return true;
    },

    downloadWord(id) {
      window.location =
        "http://164.52.196.219/pridelApiNew/Freight/wordBLConNonUs.php?id=" +
        id;
    },
    addNotify() {
      let obj = {
        inputValue: "",
        text: this.notifyArray[this.BLRaised.notifyList.length]
      };
      this.BLRaised.notifyList.push(obj);
    },
    removeNotify(index) {
      this.BLRaised.notifyList.splice(index, 1);
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    viewEditBLNonUs(item) {
      let arrayFilter = this.nonUsBlTable.filter(x => {
        return x.conFclBLNonUsId == item.conFclBLNonUsId;
      });

      this.BLRaised.notifyList = [];
      Object.keys(this.BLRaised).map(x => {
        if (x == "notifyList") {
          item[x].split("$$$").map((y, index) => {
            let obj = {
              inputValue: y,
              text: this.notifyListArray[index]
            };

            this.BLRaised.notifyList.push(obj);
          });
        } else {
          this.BLRaised[x] = item[x] || "";
        }
      });
    },
    Print(item) {
      if(!item) return;
      let key = "BL_CON/" + item;
      this.openSignedDocument(key);
    },
    validateBLRaised() {
      let validate_new = true;
      Object.keys(this.errorBLRaised).map((x, index) => {
        if (this.BLRaised[x] == "") {
          this.errorBLRaised[x] = this.arrayErrorBLRaised[0][x];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    addBLRaised() {
      this.BLRaised["ffFclConsoExportId"] = this.$sessionsStorage.get(
        "editffFclConsoExportId"
      );
      this.BLRaised["ffConExecutionId"] = this.$sessionsStorage.get(
        "editffConExecutionId"
      );
      this.BLRaised["conFclBookingId"] = this.$sessionsStorage.get(
        "editconFclBookingId"
      );
      this.BLRaised["containerDetail"] = this.containerDetail;
      // Validate that at least one container is selected
      this.BLRaised["selectedContainersData"] = this.getSelectedContainers();
      // Save selected container IDs as comma-separated string
      const selectedContainerIds = this.getSelectedContainerIds();
      this.BLRaised["selected_container"] = selectedContainerIds.join(',');
      if (!this.validateContainerSelection()) {
        return false;
      }
      this.validateBLRaised();

       

      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addConBlNonUs.php`,
          data: JSON.stringify(this.BLRaised),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              $("#loader").css("display", "none");
              $("#addButtonLoader").css("display", "block");

              if (this.BLRaised.conFclBLNonUsId != "") {
                this.alert.content = "Data updated Successfully";
              } else {
                this.alert.content = "Data Added Successfully";
              }

              Object.keys(this.BLRaised).map(x => {
                this.BLRaised[x] = "";
              });

              this.BLRaised.notifyList = [
                {
                  inputValue: "",
                  text: ""
                },
                {
                  inputValue: "",
                  text: "Second"
                }
              ];
              this.$refs["addPop"].open();

              this.getData();
              this.JqueryFun();
            }
          })
          .catch(error => {});
      }
    },
    getData() {
      this.doLoading();
      let type_Size = {
        itemCode: "itemCode",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/consofclBlNonUsGetData.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.allContainer.length > 0) {
              this.containerDetail = data.allContainer;
            }
            if (data.agentList.length > 0) {
              this.AgentList = data.agentList;
            }

            if (data.clientNamesDetails.length > 0) {
              this.BLRaised.billLading =
                data.UserData[0].BranchCode +
                data.stuffingData[0].portCode.replace(/\s+/g, "") +
                "-" +
                data.BLNO;
              this.getCLientData = data.clientNamesDetails;
              this.BLRaised.placeReceipt = data.stuffingData[0].valPOR;
              this.BLRaised.portLoad = data.stuffingData[0].valLP;
              this.BLRaised.portDischarge = data.stuffingData[0].valPodLocation;
              this.BLRaised.placeDilievery = data.stuffingData[0].valFinal;
              this.BLRaised.bookingNo = data.stuffingData[0].bookingNumber;
              this.BLRaised.typeMove = data.stuffingData[0].deliveryMode;
            } else {
              this.getCLientData = [];
            }
            if (data.ConBLNonUsData.length > 0) {
              this.BLRaised.portLocationType =
                data.ConBLNonUsData[0].portLocationType;
              this.nonUsBlTable = data.ConBLNonUsData;
              this.BLRaised.selected_container =data.ConBLNonUsData[0].selected_container;
            }
            if (data.stuffingData.length > 0) {
              this.preAlertData["ffFclConsoExportId"] =
                data.stuffingData[0].ffFclConsoExportId;
              this.preAlertData["fclConAlertId"] =
                data.stuffingData[0].fclConAlertId;
              console.log("Happy Singh Data=>", data);
            }
            if (data.ConBLNonUsData && data.ConBLNonUsData.selected_container) {
              this.autoSelectContainersFromData(data.ConBLNonUsData.selected_container);
            }
            this.doLoadingClose();
          }
        })
        .catch(error => {});
    },
 // Method to auto-select containers from saved data
 autoSelectContainersFromData(selectedContainerData) {
      console.log("priyanshu Singh containerIds1=>", selectedContainerData);
      console.log("priyanshu Singh containerDetail=>", this.containerDetail);
      if (!selectedContainerData || !this.containerDetail.length) {
        return;
      }
     
      
      try {
        // Clear all current selections first
        this.containerDetail.forEach(container => {
          container.selected = false;
        });
        
        // Handle comma-separated string format (e.g., "167477, 167478, ")
        if (typeof selectedContainerData === 'string') {
          // Split by comma and clean up whitespace and empty values
          const containerIds = selectedContainerData
            .split(',')
            .map(id => id.trim())
            .filter(id => id !== '' && id !== null && id !== undefined);
            console.log("priyanshu Singh containerIds=>", containerIds);
            console.log("priyanshu Singh containerDetail=>", this.containerDetail);
          // Select containers based on uniqueContainerId
          containerIds.forEach(containerId => {
            const container = this.containerDetail.find(item => 
              item.uniqueContainerId == containerId
            );
            
            if (container && container.containerWithSplit != 1) {
              container.selected = true;
            }
          });
        }
        
        // Update the select all state
        this.updateSelectAll();
        
        console.log('Auto-selected containers from saved data:', selectedContainerData);
      } catch (error) {
        console.error('Error auto-selecting containers:', error);
      }
    },
    
    JqueryFun() {
      return $(function() {
        return $("#portLocationNew").DataTable();
      });
    },

    previousSalesView() {
      this.$router.push({
        path: "/ffExportCon/conFclBLofLanding"
      });
    },
    proceedAws() {
      this.$sessionsStorage.set("blType", "house");
      this.$sessionsStorage.set("ffType", "fclcon");
      this.$router.push({
        path: "/ffExportCon/conAmsFilling"
      });
    },

    validateVGM() {
      let validate_new = true;
      //   Object.keys(this.errorVgmList).map((x, index) => {
      //     if (this.vgmModel[x] == "") {
      //       this.errorVgmList[x] = this.arrayErrorVgm[index];
      //       validate_new = false;
      //     }
      //   });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this item?";
      this.$refs["addPop6"].open();
    },

    onClose(type) {}
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// conBLNonUs.vue?8ce9b3ea